'use client'

import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  defaultPersonMatchDetailTab,
  type PersonMatchDetailTab,
} from '@/lib/match-detail-paths'

export function usePersonMatchDetailTab(
  evaluationId: string | null | undefined,
  hasCoverLetter = false,
) {
  const [searchParams, setSearchParams] = useSearchParams()

  const activeTab = useMemo(() => {
    const parsed = defaultPersonMatchDetailTab(evaluationId, searchParams.get('tab'))
    if (parsed === 'letter' && !hasCoverLetter) return evaluationId ? 'analysis' : 'profile'
    return parsed
  }, [evaluationId, hasCoverLetter, searchParams])

  const setActiveTab = useCallback(
    (tab: PersonMatchDetailTab) => {
      const next = new URLSearchParams(searchParams)
      next.set('tab', tab)
      setSearchParams(next, { replace: true })
    },
    [searchParams, setSearchParams],
  )

  return { activeTab, setActiveTab }
}
